import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { Publisher } from '../model/publisher.class';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-publisher-update',
    templateUrl: './publisher.update.component.html'
})
export class PublisherUpdateComponent {

    public publisher: Publisher;

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['publisherId'], 'publisher').subscribe(publisher => {
                    this.publisher = publisher as Publisher;

                });
            });

    }

    updatePublisher() {
        this.userService.update(this.publisher, 'publisher')
            .subscribe(() => {
                if (this.userService.user.publisher.publisherId === this.publisher.publisherId) {
                    this.userService.user.publisher = this.publisher;
                }
                if (this.userService.user.userType === this.userService.Admin) {
                    this.router.navigate(['/publisher/list']);
                } else {
                    this.router.navigate(['/publisher/detail', this.publisher.publisherId]);
                }
            },
            (err) => {
                this.message = 'Alle Pflichtfelder ausfüllen!';
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherUpdate/publisher.update.component.ts